import { useEffect, useState } from 'react';

export interface AsyncState<T> {
  loading: boolean;
  error: Error | null;
  value: T | undefined;
}

/** Run an async loader and re-run whenever any dependency changes. */
export function useAsync<T>(loader: () => Promise<T>, deps: readonly unknown[]): AsyncState<T> {
  const [state, setState] = useState<AsyncState<T>>({ loading: true, error: null, value: undefined });

  useEffect(() => {
    let active = true;
    setState((s) => ({ ...s, loading: true }));
    loader()
      .then((value) => {
        if (active) setState({ loading: false, error: null, value });
      })
      .catch((error: Error) => {
        if (active) setState({ loading: false, error, value: undefined });
      });
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return state;
}
